import styled, { css } from 'styled-components';

export const SalesOnboardingTitle = styled.h5.attrs(() => ({
  className: 'SalesOnboardingTitle',
}))`
  margin: 20px 0 40px 0;
  font-size: 24px;
  font-weight: 500;
`;
